import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";

const TeachingPrefrences = ({ setTeachingPrefrencesIndication}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();

  const getListDataByid = async () => {
    setIsLoading(true);
    const data = {
      id: parmas?.mid,
    };
    await tutorsModal
      .TeachingPreferencelist(data)
      .then((result) => {
        setIsLoading(false);
       
        if (result) {
          setDataList(result?.data?.data);
          if(result?.data?.data.length > 0){
          setTeachingPrefrencesIndication(true)
        }else{
          setTeachingPrefrencesIndication(false)
        }
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (parmas.mid != "") {
      getListDataByid();
    }
  }, []);

  // const du = new DeviceUUID();
  // const uuid = du.get();
  const handleDownload = (url) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);

  const [modal2, setModal2] = useState(false);
  const toggle2 = () => setModal2(!modal2);

  const [interviewUserList, setInterviewUserList] = useState([]);
  const getListDatainterViewUSer = async () => {
    setIsLoading(true);
    
    // Dummy data for interview user list
    const dummyInterviewers = [
      {
        mobile: "9876543210",
        name: "Dr. Rajesh Kumar"
      },
      {
        mobile: "9876543211",
        name: "Prof. Sunita Sharma"
      },
      {
        mobile: "9876543212",
        name: "Mr. Amit Verma"
      },
      {
        mobile: "9876543213",
        name: "Ms. Priya Gupta"
      }
    ];
    
    setTimeout(() => {
      setIsLoading(false);
      setInterviewUserList(dummyInterviewers);
    }, 500);
  };

  useEffect(() => {
    getListDatainterViewUSer();
  }, []);

  const [selectuser, setSelectdUser] = useState("");
  const interViewUser = (id) => {
    setSelectdUser(id);
  };
  console.log(selectuser, "selectuser");

  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();

  const [meetingDate, setMeetingDate] = useState("");
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("DD/MM/YYYY");
  const [startTime, setStartTime] = useState(""); // State to store start time
  const [endTime, setEndTime] = useState(""); // State to store end time
  const [interviewLink, setInterViewLink] = useState("");

  // Function to handle changes in the start time input
  const handleStartTimeChange = (event) => {
    const { value } = event.target;
    setStartTime(value); // Update startTime state with the selected time
  };

  // Function to handle changes in the end time input
  const handleEndTimeChange = (event) => {
    const { value } = event.target;
    setEndTime(value); // Update endTime state with the selected time
  };

  const handleInterViewLink = (event) => {
    const { value } = event.target;
    setInterViewLink(value); // Update endTime state with the selected time
  };

  const handleSubmitAddedInterView = (event) => {
    event.preventDefault();
    const formdata = new FormData();
    formdata.append("tutor", parmas?.mid);
    formdata.append("interviewer", selectuser);
    formdata.append("interview_link", interviewLink);
    formdata.append("interview_date", formattedDate);
    formdata.append("start_time",moment(startTime, "HH:mm").format("hh:mm A"));
    formdata.append("end_time",moment(endTime, "HH:mm").format("hh:mm A"));
    

    SubAdminModal.InterviewSchedule(formdata)
      .then((response) => {
        console.log(response, "forminterdfview");
        // helper.sweetalert.toast("Interview Shedule.", "success");
        // toggle()
        // setAddsLoadig(false);
      })
      .catch((error) => {
        console.log(error, "forminterview");
        // setAddsLoadig(false);
        // console.log(error);
      });
  };

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
      <Table>
  <thead>
    <tr style={{ background: "#F6F9FC" }}>
      <th id="tableheding">SN No.</th>
      <th id="tableheding">Category</th>
      <th id="tableheding">Board</th>
      <th id="tableheding">Classes</th>
      <th id="tableheding">Subject</th>
      <th id="tableheding">Answer</th>
      <th id="tableheding">Status</th>
      {/* <th>Action</th> */}
    </tr>
  </thead>
  {!isLoading && (
    <tbody>
      {dataList.length > 0 ? (
        dataList
          ?.slice()
          .reverse()
          .map((item, index) => {
            return (
              <tr key={item.id} className="vertical-align-middle" style={{ cursor: "pointer", verticalAlign: "middle" }}>
                <td  id="tabledata">{index + 1}</td>
                {item?.preference?.map((data, index) => {
                  return <td key={index} id="tabledata">{data?.name || "-"}</td>;
                })}
                {[...Array(Math.max(0, 4 - (item.preference?.length || 0)))].map((_, index) => (
                  <td key={index + item.preference?.length} id="tabledata"> - </td>
                ))}
                <td  id="tabledata">
                  <i
                    className="fa-solid fa-file"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDownload(item?.answer)}
                  />
                </td>
                <td id="tabledata">{item?.status || "-"}</td>
              
              </tr>
            );
          })
      ) : (
        <tr style={{ textAlign: "center", verticalAlign: "middle" }}>
          <td colSpan="6">No data found</td>
        </tr>
      )}
    </tbody>
  )}
</Table>

        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <h4>Interview Schedule Turos</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Select Interviewer</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    {interviewUserList &&
                      interviewUserList.map((item, index) => {
                        return <option value={item.mobile}>{item.name}</option>;
                      })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Meeting Link</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="text"
                    // name="interview_link"
                    placeholder="Enter meeting link"
                    value={interviewLink} // Set the value of the input field to the meetingDate state
                    onChange={handleInterViewLink}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="meetingDate">Meeting Date</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="date"
                    id="meetingDate"
                    // name="interview_date"
                    placeholder="Select meeting date"
                    value={meetingDate} // Set the value of the input field to the meetingDate state
                    onChange={handleDateChange} // Call handleDateChange function when the date is changed
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="startTime">Start Time</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="time"
                    id="startTime"
                    value={startTime} // Convert to 12-hour format
                    onChange={handleStartTimeChange} // Call handleStartTimeChange function when the time is changed
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="endTime">End Time</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="time"
                    id="endTime"
                    value={endTime} // Convert to 12-hour format
                    onChange={handleEndTimeChange} // Call handleEndTimeChange function when the time is changed
                  />
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={handleSubmitAddedInterView}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggle2}>
          <ModalHeader toggle={toggle2}>
            <h4>Interview Status Chnage</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Status</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    <option value="">Qualified </option>
                    <option value="">Not Qualified </option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Feedback</Label>
                  <Input
                    id="type"
                    name="Feedback"
                    type="textarea"
                    placeholder="Enter Feedback"
                  />
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle2}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={handleSubmitAddedInterView}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal1} toggle={toggle1}>
          <ModalHeader toggle={toggle1}>
            <h4>Interview Schedule User List</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Select Interviewer</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    {interviewUserList &&
                      interviewUserList.map((item, index) => {
                        return <option value={item.mobile}>{item.name}</option>;
                      })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Meeting Link</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="text"
                    // name="interview_link"
                    placeholder="Enter meeting link"
                    value={interviewLink} // Set the value of the input field to the meetingDate state
                    onChange={handleInterViewLink}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="meetingDate">Meeting Date</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="date"
                    id="meetingDate"
                    // name="interview_date"
                    placeholder="Select meeting date"
                    value={meetingDate} // Set the value of the input field to the meetingDate state
                    onChange={handleDateChange} // Call handleDateChange function when the date is changed
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="startTime">Start Time</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="time"
                    id="startTime"
                    value={startTime} // Convert to 12-hour format
                    onChange={handleStartTimeChange} // Call handleStartTimeChange function when the time is changed
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="endTime">End Time</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="time"
                    id="endTime"
                    value={endTime} // Convert to 12-hour format
                    onChange={handleEndTimeChange} // Call handleEndTimeChange function when the time is changed
                  />
                </FormGroup>
              </Col>
              {/* <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Select Interviewer</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    <option value="">Pending</option>
                    <option value="">Interview scheduled</option>
                   
                  </Input>
                </FormGroup>
              </Col> */}
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={handleSubmitAddedInterView}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>

      <br />
    </div>
  );
};

export default TeachingPrefrences;
